import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}

export const CheckIcon: FC<IconProps> = ({ className, size = 24 }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 24 25'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M20.1515 7.55061C20.489 7.92561 20.489 8.48811 20.1515 8.82561L10.2515 18.7256C9.87647 19.1006 9.31396 19.1006 8.97647 18.7256L3.87646 13.6256C3.50146 13.2881 3.50146 12.7256 3.87646 12.3881C4.21396 12.0131 4.77646 12.0131 5.11396 12.3881L9.57647 16.8506L18.8765 7.55061C19.214 7.21311 19.7765 7.21311 20.114 7.55061H20.1515Z'
        }
        fill={'#22242D'}
      />
    </svg>
  )
}
